import Vue from 'vue'
import App from './App.vue'

import store from './store'

import router from './router'

// models
import Realisation from './models/Realisation'
import Location from './models/Location'
import Request from './models/Request'

//import EvtoolsTour from '@evtools/tour'

// Polyfill Fetch
import 'whatwg-fetch'

// Polyfill Buffer
if (! window.Buffer) {
  window.Buffer = require('buffer').Buffer
}

// AlertPlugin, ButtonPlugin, IconsPlugin, InputGroupPlugin, FormInputPlugin, FormSelectPlugin, ListGroupPlugin, NavPlugin, PaginationPlugin
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import PrimeVue from 'primevue/config'

import './assets/sass/bootstrap.scss'
import './assets/sass/index.scss'
import 'primevue/resources/themes/saga-blue/theme.css'      //theme
import 'primevue/resources/primevue.min.css'                 //core css
import 'primeicons/primeicons.css'                           //icons
import { locale } from '@/primevueLocale'

Vue.use(BootstrapVue)
Vue.use(PrimeVue, { locale }) // use dutch translations
Vue.use(IconsPlugin)
//Vue.use(EvtoolsTour)

Vue.config.productionTip = false

// The Vue instance
let instance = null

/**
 * Vue notifications
 * todo:: use more lightweight notification system
 */
// import Notifications from 'vue-notification'
// Vue.use(Notifications) // 20 sec 20000

// Auth0 - TODO: Move plugin code to npm module
import { Auth0Plugin } from './auth'
Vue.use(Auth0Plugin, {
  domain: process.env.VUE_APP_AUTH_DOMAIN,
  clientId: process.env.VUE_APP_AUTH_CLIENTID,
  audience: process.env.VUE_APP_AUTH_AUDIENCE,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname,
    )
  },
})


import { NotificationPlugin } from '@/notification-plugin.js'
Vue.use(NotificationPlugin)

/**
 * Make the Central Backend API Service available throughout the application
 */
import { CBAPIPlugin } from '@/services/cbapi.js'
Vue.use(CBAPIPlugin, {
  errorLogger: async ({ method, error, response }) => {

    console.log('ERRORHANDLER...', response, method, error)

     if (!response) console.log('NO RESPONSE')

    else if (response?.status === 400) {
      console.log('validation error')

      try {
        let text = await response.text()
        try {
          console.log(JSON.parse(text))
        } catch (e) {
          console.log(text)
        }
      } catch (err) {
        console.log(err)
      }

      Vue.prototype.$notify({
        error: true,
        title: 'De wijziging is niet opgeslagen',
        text: 'De invoer voldoet niet aan de gestelde criteria. Controleer voor details het formulier.',
      })
    }

    else if (response?.status === 403) {
      console.log('Permission error')

      Vue.prototype.$notify({
        error: true,
        title: 'De wijziging is niet opgeslagen',
        text: 'U heeft niet voldoende rechten om deze handeling uit te voeren.',
      })
    }

    else if (response?.status === 404) {
      console.log('Not found error')

      Vue.prototype.$notify({
        error: true,
        title: 'Niet gevonden',
        text: 'De door u opgevraagde data kon niet worden gevonden.',
      })
    }

    else if (response?.status === 409) {
      console.log('Sync error')

      try {
        let text = await response.text()
        try {
          console.log(JSON.parse(text))
        } catch (e) {
          console.log(text)
        }
      } catch (err) {
        console.log(err)
      }

      Vue.prototype.$notify({
        error: true,
        title: 'De wijziging is niet opgeslagen',
        text: 'Uw data van dit record is verouderd ten opzichte van de data in de database. Ververs uw data onder aan de overzichtspagina.',
      })
    }

    else if (response?.status === 500) {
      console.log('Critical error')

      try {
        let text = await response.text()
        try {
          console.log(JSON.parse(text))
        } catch (e) {
          console.log(text)
        }
      } catch (err) {
        console.log(err)
      }

      Vue.prototype.$notify({
        error: true,
        title: 'Een onverwachte fout heeft zich voorgedaan',
        text: 'Vanwege een onverwachte situatie is iets mis gegaan. Neem a.u.b. contact op met support@evtools.nl.',
      })
    }

    else {
      console.log('Uncategorized error')

      try {
        let text = await response.text()
        try {
          console.log(JSON.parse(text))
        } catch (e) {
          console.log(text)
        }
      } catch (err) {
        console.log(err)
      }

      if (method === 'GET') {
        Vue.prototype.$notify({
          error: true,
          title: 'De data kon niet opgehaald worden',
          text: 'Het is niet gelukt om de data op te halen. Neem bij herhaling contact op met support@evtools.nl.',
        })

      } else if (['POST', 'PUT'].includes(method)) {
        Vue.prototype.$notify({
          error: true,
          title: 'De data kon niet opgeslagen worden',
          text: 'Het is niet gelukt om de data op te slaan. Neem bij herhaling contact op met support@evtools.nl.',
        })

      } else {
        Vue.prototype.$notify({
          error: true,
          title: 'De API interactie is mislukt ',
          text: 'Neem bij herhaling contact op met support@evtools.nl.',
        })
      }
    }

    return false
  },
})

/**
 * Init Geocoder
 */

import { initGoogleAPILoader } from '@/services/geocoder'
initGoogleAPILoader()

import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo)
instance = new Vue({
  router,
  store,
  render: h => h(App),
})

// bind auth0 Plugin to the store, so we can retrieve there the token as well
instance.$store.$auth = instance.$auth
// bind cbapi Plugin to the store, so we can easily make API calls there as well
instance.$store.$cbapi = instance.$cbapi

// bind store to models
Realisation.prototype.$store = instance.$store
Location.prototype.$store = instance.$store
Request.prototype.$store = instance.$store

instance.$mount('#app')

// Set initial userSettings local storage object, only if non-existent //
if (!localStorage.getItem('userSettings')) {
  localStorage.setItem('userSettings', JSON.stringify({}))
}
